var type = function type(x) {
  return Object.prototype.toString.call(x).slice(8, -1);
};

var isEmpty = function isEmpty(x) {
  return type(x) === 'Object' && Object.keys(x).length === 0 || type(x) === 'Null' || type(x) === 'Undefined';
};

var get = function get(path, obj, defaultValue) {
  var head = path[0];
  var tail = path.slice(1);

  if (!tail.length) {
    return isEmpty(obj[head]) ? defaultValue : obj[head];
  }

  return get(tail, obj[head], defaultValue);
};

var withMinAndMaxMedia = function withMinAndMaxMedia(x, y) {
  return "@media (min-width: ".concat(x, ") and (max-width: ").concat(y, ")");
};

var makeErrorMessage = function makeErrorMessage(breakName, breaks) {
  return "'".concat(breakName, "' is invalid breakpoint name. Use '").concat(Object.keys(breaks).join(', '), "'.");
};

module.exports = {
  type: type,
  get: get,
  withMinAndMaxMedia: withMinAndMaxMedia,
  makeErrorMessage: makeErrorMessage,
  isEmpty: isEmpty
};